export default __webpack_public_path__ + "static/media/backgroundSFX.72adc4f3.mp3";